import React, { useMemo } from "react";

import { ListGroup } from "react-bootstrap"

import constants from "../../lib/constants"
import CompanyGroupItem from "./CompanyGroupItem";

const parser = (data) => {
    return data
        .map((item) => (
            {
                company_id: item.company_id,
                points: item.points,
                percent: item.percent,
                value: item.value,
                label: item.label,
                title: item.title,
                website_url: item.website_url ? item.website_url : '/',
                vendor_url: item.vendor_url ? `/company/${item.vendor_url}` : '#',
                logo_url: item.logo_url ? `${constants.LOGO_URL}/${item.logo_url}` : '#',
                founded: item.founded || '',
                location: `${item.location_city}, ${item.location_country.value}`,
                company_size: (item.company_size || '').replace('employees', ''),
                hourly_rate: item.hourly_rate,
                minimal_project: item.project_minimal,
                ready_to_start: item.ready_to_start,
                tagline: item.tagline,
                clients: (item.clients.length >= 12) ? item.clients.slice(0, 12) : item.clients || [],
                description: item.description,
                row_count: item.row_count,
                is_sponsor: item.is_sponsor,
                focus_name: item.focus_name,
                focus: item.focus,
                score: item.score || []
            }
        ));
}

const CompanyListGroup = (props) => {
    const { linkage, headlines, initialData } = props;
    const data = useMemo(() => (initialData.length > 15) ? parser(initialData.slice(0, 15)) : parser(initialData), [initialData]);

    return (
        <section className={props.className}>
            <h2 className="mb-4">{headlines.mainTitle2}</h2>
            <div className="card border rounded-0 shadow-none mb-5">
                <ListGroup className="rounded-0">
                    {data.map((item, index) => (
                        <ListGroup.Item action className={`p4 border-0 ${index === data.length - 1 ? "" : "border-bottom"}`} key={index}>
                            <CompanyGroupItem key={index} item={item} linkage={linkage} />
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </div>
        </section>
    )
}

export default CompanyListGroup